import { render, staticRenderFns } from "./LocationPopupData.vue?vue&type=template&id=2165f15e&scoped=true&"
import script from "./LocationPopupData.vue?vue&type=script&lang=js&"
export * from "./LocationPopupData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165f15e",
  null
  
)

export default component.exports